import type { FaireProductEntity } from "../../entity_types/product";

export const p_d2tcuvfnh6: FaireProductEntity = {
  token: "p_d2tcuvfnh6",
  type: "product",
  name: "BAR MONTI",
  brandToken: "b_aqjro3p2",
  brandName: "ROEN",
  imageUrl:
    "https://cdn.faire.com/fastly/cd8801d104878df04ed8b1aea894c35d3901953fb25c925a40de6cbf83c48606.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/0b77b41c8062678a1c78d54267bdaee94b34d3b6dca999ce9d73ed2986291b9f.jpeg",
    "https://cdn.faire.com/fastly/eb626a379d8f97cc76a36983a8e481aed0801cbc3ca9aacdb9bbe35c116ec2cb.jpeg",
    "https://cdn.faire.com/fastly/7e6f32323ba7dd84fd1bd9504cd8e672b20f87e10f337f50c14cd51d9752513b.jpeg",
  ],
  priceDollars: 19,
  description:
    "Hidden away in one of our favorite neighborhoods in Rome. What was once home to brothels and ruins is now brimming with young artists and creatives. Crooked cobblestone streets give way to busy bars and ivy covered patios while the lingering sound of jazz and subtle presence of kush fill the air. \n\nkush, pepperwood, labdanum, creamy sandalwood, dry musk\n\nRoen candles are hand poured in our Southern California studio using a coconut + soy wax blend for a natural, clean burn.  We use lead-free cotton wicks and premium fragrance oils.  All of our candles are vegan, cruelty-free, phthalate-free, paraben-free, carcinogen-free and packaged in fully recyclable materials. \n\n8 ounces (226g), comes in our signature Italia box.",
  tags: [],
  msrpDollars: 38,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T13:49:24.834Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
